<template>
  <v-container class="main-container">
    <message-component id="message" v-model="isMessage" :success="success">{{ message }}</message-component>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-overlay :value="sending" z-index="10000">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
        <span class="loading">処理中です...</span>
      </v-overlay>
      <p class="text-h3 my-4">
          DX-Signユーザー登録
      </p>
      <v-stepper v-model="curr" color="green">
        <!--有料プラン-->
        <v-stepper-header class="overflow-x-auto" v-if="plan_flg">
          <template v-for="(step,n) in steps">
            <v-stepper-step
                :key="n"
                :complete="stepComplete(n+1)"
                :step="n+1"
                :color="stepStatus(n+1)">
                {{ step.name }}
            </v-stepper-step>
            <v-divider v-if="n+1 < lastStep"></v-divider>
          </template>
        </v-stepper-header>
        <!--無料プラン-->
        <v-stepper-header class="overflow-x-auto" v-else>
          <template v-for="(step,n) in freeSteps">
            <v-stepper-step
                :key="n"
                :complete="stepComplete(n+1)"
                :step="n+1"
                :color="stepStatus(n+1)">
                {{ step.name }}
            </v-stepper-step>
            <v-divider v-if="n+1 < 2"></v-divider>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <!--基本情報-->
          <v-stepper-content step="1">
            <v-card
              flat
              class="my-4"
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="2" class="text-right">
                    <badge-component tile content="必　須" color="red">
                        <label-component>氏名</label-component>
                    </badge-component>
                  </v-col>
                  <v-col cols="6">
                      <validation-provider
                        v-slot="{ errors }"
                        name="user_name"
                        rules="required|max:255"
                      >
                        <v-text-field
                          v-model="user_name"
                          :error-messages="errors"
                          placeholder="利用するお客様のお名前をご入力ください"
                          required
                          outlined
                          clearable
                          v-disabled-icon-focus
                        ></v-text-field>
                      </validation-provider>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="2" class="text-right">
                    <badge-component tile content="必　須" color="red">
                      <label-component>利用プラン</label-component>
                    </badge-component>
                  </v-col>
                  <v-col cols="6">
                      <validation-provider
                        v-slot="{ errors }"
                        name="plan"
                        rules="required"
                      >
                        <v-select
                          v-model="plan"
                          :items="list['plans']"
                          :error-messages="errors"
                          placeholder="利用するプラン名を選択ください"
                          hint="※現在ノーマルプランは基本料無料キャンペーンを行っております"
                          persistent-hint
                          data-vv-name="plan"
                          outlined
                          required
                        ></v-select>
                      </validation-provider>
                  </v-col>
                </v-row>
                <v-btn color="red" @click="curr = 2" class="my-4 white--text" :disabled="!(user_name && plan)" v-if="plan_flg">
                  次へ
                </v-btn>
                <v-btn color="red" @click="curr = 4" class="my-4 white--text" :disabled="!(user_name && plan)" v-else>
                  次へ
                </v-btn>
              </v-card-text>
            </v-card>
          </v-stepper-content>
          <!--END 基本情報-->
  
          <!--企業情報-->
          <v-stepper-content step="2" v-if="plan_flg">
            <v-card
            　flat
              class="my-4"
            >
              <v-card-text>
                <v-form ref="form" v-model="valid">
                  <v-row>
                    <v-col cols="2" class="text-right">
                      <badge-component tile content="必　須" color="red">
                        <label-component>会社名</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="4">
                        <validation-provider
                          v-slot="{ errors }"
                          name="company_name"
                          rules="required|max:255"
                        >
                          <v-text-field
                            v-model="company_name"
                            :error-messages="errors"
                            placeholder="貴社名をご入力ください"
                            outlined
                            required
                            clearable
                            v-disabled-icon-focus
                          ></v-text-field>
                        </validation-provider>
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <badge-component tile content="任　意">
                        <label-component>代表者名</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="3">
                        <validation-provider
                          v-slot="{ errors }"
                          name="representative"
                          rules="max:255"
                        >
                          <v-text-field
                            v-model="representative"
                            :error-messages="errors"
                            outlined
                            clearable
                            v-disabled-icon-focus
                          ></v-text-field>
                        </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" class="text-right">
                      <badge-component tile content="必　須">
                        <label-component>住所</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="4">
                        <validation-provider
                          v-slot="{ errors }"
                          name="zip_code"
                          rules="required|digits:7"
                        >
                        <v-text-field
                          v-model="zip_code"
                          :error-messages="errors"
                          placeholder="郵便番号（入力すると住所が出力されます）"
                          hint="ハイフン無しでご入力ください"
                          outlined
                          clearable
                          v-disabled-icon-focus
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="2">
                        <validation-provider
                          v-slot="{ errors }"
                          name="address_prefecture"
                          rules="required"
                        >
                          <v-select
                            v-model="address_prefecture"
                            :items="list['prefectures']"
                            :error-messages="errors"
                            data-vv-name="address_prefecture"
                            placeholder="ご選択ください"
                            outlined
                            clearable
                            v-disabled-icon-focus
                          ></v-select>
                        </validation-provider>
                    </v-col>
                    <v-col cols="3">
                        <validation-provider
                          v-slot="{ errors }"
                          name="address_city"
                          rules="required|max:255"
                        >
                          <v-text-field
                            v-model="address_city"
                            :error-messages="errors"
                            placeholder="例：　千代田区七番町"
                            outlined
                            clearable
                            v-disabled-icon-focus
                          ></v-text-field>
                        </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2">
                    </v-col>
                    <v-col cols="4">
                      <validation-provider
                        v-slot="{ errors }"
                        name="address_address1"
                        rules="required|max:255"
                      >
                        <v-text-field
                          v-model="address_address1"
                          :error-messages="errors"
                          placeholder="例： 〇丁目△番地"
                          outlined
                          clearable
                          v-disabled-icon-focus
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="5">
                      <validation-provider
                        v-slot="{ errors }"
                        name="address_address2"
                        rules="max:255"
                      >
                        <v-text-field
                          v-model="address_address2"
                          :error-messages="errors"
                          placeholder="例： 〇△ビル３階"
                          outlined
                          clearable
                          v-disabled-icon-focus
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" class="text-right">
                      <badge-component tile content="任　意">
                        <label-component>電話番号</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="4">
                        <validation-provider
                          v-slot="{ errors }"
                          name="TEL"
                          rules="numeric|min:10|max:11"
                        >
                          <v-text-field
                            v-model="tel"
                            :error-messages="errors"
                            placeholder="例：　07012345678"
                            hint="ハイフン無しでご入力ください"
                            outlined
                            clearable
                            v-disabled-icon-focus
                          ></v-text-field>
                        </validation-provider>
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <badge-component tile content="必　須" color="red">
                        <label-component>業種</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="3">
                        <validation-provider
                            v-slot="{ errors }"
                            name="industry_id"
                            rules="required"
                        >
                          <v-select
                              v-model="industry_id"
                              :error-messages="errors"
                              :items="list['industries']"
                              placeholder="ご選択ください"
                              outlined
                              required
                              clearable
                              v-disabled-icon-focus
                          ></v-select>
                        </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2" class="text-right">
                      <badge-component tile content="任　意">
                        <label-component>従業員数</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="4">
                        <validation-provider
                          v-slot="{ errors }"
                          name="employee_number"
                        >
                          <v-select
                            v-model="employee_number"
                            :items="list['employees']"
                            :error-messages="errors"
                            data-vv-name="employee_number"
                            placeholder="ご選択ください"
                            outlined
                            clearable
                            v-disabled-icon-focus
                          ></v-select>
                        </validation-provider>
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <badge-component tile content="任　意">
                        <label-component>URL</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="3">
                        <validation-provider
                          v-slot="{ errors }"
                          name="url"
                          rules="max:255"
                        >
                          <v-text-field
                            v-model="url"
                            :error-messages="errors"
                            placeholder="例： https://www.example.com"
                            outlined
                            clearable
                            v-disabled-icon-focus
                          ></v-text-field>
                        </validation-provider>
                    </v-col>
                  </v-row>
                    <v-btn @click="curr = 1" class="my-4 mr-4 white--text" color="blue-grey lighten-3">
                      戻る
                    </v-btn>
                    <v-btn color="red" @click="curr = 3" class="my-4 white--text" :disabled="!(valid && company_name && industry_id && zip_code && address_prefecture && address_city && address_address1)">
                      次へ
                    </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-stepper-content>
          <!--END 企業情報-->

          <!--請求先情報-->
          <v-stepper-content step="3" v-if="plan_flg">
            <v-card
            　flat
              class="my-2"
            >
              <v-card-text>
                <v-form ref="form" v-model="valid2">
                  <v-row>
                    <v-col cols="1"></v-col>
                    <v-col cols="11">
                      <v-checkbox
                          v-model="checkbox"
                          :label="`すでに入力した情報を反映する`"
                          v-on:change="copy()"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="3" class="text-right">
                      <badge-component tile content="必　須" color="red">
                          <label-component>請求担当者名</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="3">
                        <validation-provider
                          v-slot="{ errors }"
                          name="billing_name"
                          rules="required|max:255"
                        >
                          <v-text-field
                            v-model="billing_name"
                            :error-messages="errors"
                            outlined
                            clearable
                            v-disabled-icon-focus
                            required
                          ></v-text-field>
                        </validation-provider>
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <badge-component tile content="必　須" color="red">
                          <label-component>支払い方法</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="3">
                        <validation-provider
                          v-slot="{ errors }"
                          name="payment_method"
                          rules="required"
                        >
                          <v-select
                            v-model="payment_method"
                            :items="list['payment_methods']"
                            :error-messages="errors"
                            data-vv-name="payment_method"
                            outlined
                            required
                            clearable
                            v-disabled-icon-focus
                          ></v-select>
                        </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3" class="text-right">
                      <badge-component tile content="必　須" color="red">
                          <label-component>請求先<br>メールアドレス</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="3">
                        <validation-provider
                          v-slot="{ errors }"
                          name="billing_email_address_main"
                          rules="required|email"
                        >
                         <v-text-field
                            v-model="billing_email_address_main"
                            :error-messages="errors"
                            outlined
                            clearable
                            v-disabled-icon-focus
                            required
                          ></v-text-field>
                        </validation-provider>
                    </v-col>
                    <v-col cols="2" class="text-right">
                      <badge-component tile content="必　須" color="red">
                          <label-component>請求先<br>電話番号</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="3">  
                      <validation-provider
                        v-slot="{ errors }"
                        name="billing_tel"
                        rules="required|numeric|min:10|max:11"
                      >
                        <v-text-field
                          v-model="billing_tel"
                          :error-messages="errors"
                          hint="ハイフン無しでご入力ください"
                          outlined
                          clearable
                          v-disabled-icon-focus
                          required
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>  
                  <v-row>
                    <v-col cols="3" class="text-right">
                      <badge-component tile content="任　意">
                          <label-component>（予備）請求先<br>メールアドレス</label-component>
                      </badge-component>
                    </v-col>
                    <v-col cols="3">
                        <validation-provider
                          v-slot="{ errors }"
                          name="billing_email_address_sub"
                          rules="email"
                        >
                         <v-text-field
                            v-model="billing_email_address_sub"
                            :error-messages="errors"
                            outlined
                            clearable
                            v-disabled-icon-focus
                          ></v-text-field>
                        </validation-provider>
                    </v-col>
                    <v-col cols="2" class="text-right">    
                    <badge-component tile content="任　意">
                        <label-component>請求先<br>部署名</label-component>
                    </badge-component>
                    </v-col>
                    <v-col cols="3">
                        <validation-provider
                          v-slot="{ errors }"
                          name="billing_department"
                          rules="max:255"
                        >
                          <v-text-field
                            v-model="billing_department"
                            :error-messages="errors"
                            outlined
                            clearable
                            v-disabled-icon-focus
                          ></v-text-field>
                        </validation-provider>
                    </v-col>
                  </v-row>
                  <v-btn @click="curr = 2" class="my-4 mr-4 white--text" color="blue-grey lighten-3">
                    戻る
                  </v-btn>
                  <v-btn color="red" @click="curr = 4" class="my-4 white--text"
                    :disabled="!(valid2 && billing_name && payment_method && billing_email_address_main && billing_tel)"
                  >
                    次へ
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-stepper-content>
          <!--END 請求先情報-->

          <!--確認画面-->
          <v-stepper-content step="4">
            <v-card
              flat
              class="my-4"
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required"
                      name="agree_check"
                    >
                      <v-checkbox
                        v-model="agree_check"
                        :error-messages="errors"
                        value="1"
                        type="checkbox"
                        required
                      >
                        <template v-slot:label>
                          <a
                            target="_blank"
                            href="/documents/terms"
                            @click.stop
                          >
                            利用規約
                          </a>
                          を確認および同意した上で、サービスを利用します
                        </template>
                      </v-checkbox>
                    </validation-provider>
                  </v-col>
                </v-row>
                  <v-btn @click="curr = 1" class="my-4 mr-4 white--text" color="blue-grey lighten-3" style="float: left;">
                    戻る
                  </v-btn>
                  <v-btn color="red" @click="submit" class="my-4 white--text" :disabled="invalid">
                    登録
                  </v-btn>
              </v-card-text>
            </v-card>
          </v-stepper-content>
          <!--END 確認画面-->
        </v-stepper-items>
      </v-stepper>
    </validation-observer>
  </v-container>
</template>

<script>
  import { required, digits, email, max, min, numeric } from 'vee-validate/dist/rules';
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
  const jsonpAdapter = require('axios-jsonp');

  extend('digits', {
    ...digits,
    message: '半角数字 {length} 桁でご入力ください',
  });

  extend('required', {
    ...required,
    message: '入力必須項目です',
  });

  extend('email', {
    ...email,
    message: '正しいメールアドレスをご入力ください',
  });

  extend('max', {
    ...max,
    message: '{length} 文字以内でご入力ください',
  });

  extend('min', {
    ...min,
    message: '{length} 文字以上でご入力ください',
  });

  extend('numeric', {
    ...numeric,
    message: '半角数字でご入力ください',
  });

  export default {
        components: {
          ValidationProvider,
          ValidationObserver,
        },
        data: function () {
            return {
                valid: true,
                valid2: true,
                val: [],
                plan: '',
                curr: 1,
                lastStep: 4,
                steps: [
                    {name: "基本情報"},
                    {name: "企業情報"},
                    {name: "請求先情報"},
                    {name: "確認"},
                ],
                freeSteps: [
                    {name: "基本情報"},
                    {name: "確認"},
                ],
                checkbox: false,
                plan_flg: true,
                company_name: null,
                representative: null,
                tel: null,
                zip_code: null,
                address_city: null,
                address_address1: null,
                address_address2: null,
                industry_id: null,
                url: null,
                user_name: null,
                address_prefecture: null,
                employee_number: null,
                billing_department: null,
                billing_name: null,
                billing_tel: null,
                billing_email_address_main: null,
                billing_email_address_sub: null,
                payment_method: null,
                agree_check: null,
                // メッセージ
                message: null,
                success: false,
                aid: null,
                sending: false,
            };
        },
        props: {
            list: Object,
            //仮登録時のメールアドレスを取得
            user_email: {
              type: Object
            },
        },
        watch: {
            // 住所検索
            'zip_code': function(next, prev) {
                // バリデーションチェック
                const reg = /^\d{7}$/;
                if (!reg.test(next)) return;

               axios({
                    url: `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${next}`,
                    adapter: jsonpAdapter, // requireしたアダプタを利用
                })
                .then((response) => {
                    this.address_prefecture = response.data.results[0].address1; // 都道府県
                    this.address_city = response.data.results[0].address2 + response.data.results[0].address3; // 市区町村
                }).catch(res => {
                    // console.log(res);
                    this.success = false;
                    this.message = "該当する住所が見つかりませんでした";
                })
                .finally(() => {
                });
            },
            // プラン選択
            'plan': function(next, prev) {
              if (next != 'free') {
                this.plan_flg = true;
              } else {
                this.plan_flg = false;
              }
            },
        },
        methods: {
          stepComplete(step) {
              return this.curr > step;
          },
          stepStatus(step) {
              return this.curr > step ? 'green' : 'blue';
          },
          copy() {
            if(this.checkbox == true){
              this.billing_name = this.user_name;
              this.billing_tel = this.tel;
              this.billing_email_address_main = this.user_email.email;
            } else {
              this.billing_name = null;
              this.billing_tel = null;
              this.billing_email_address_main = null;
            }
          },
          // 登録
          submit: async function (tkn) {
            this.sending = true;
            // バリデーション実行
            await this.$refs.observer.validate().then((result) => {
              if(result) {
                var params = {
                    'plan': this.plan,
                    'company_name': this.company_name,
                    'zip_code': this.zip_code,
                    'address_prefecture': this.address_prefecture,
                    'address_city': this.address_city,
                    'address_address1': this.address_address1,
                    'address_address2': this.address_address2,
                    'industry_id': this.industry_id,
                    'representative': this.representative,
                    'tel': this.tel,
                    'employee_number': this.employee_number,
                    'url': this.url,
                    'user_name': this.user_name,
                    'billing_department': this.billing_department,
                    'billing_name': this.billing_name,
                    'billing_tel': this.billing_tel,
                    'billing_email_address_main': this.billing_email_address_main,
                    'billing_email_address_sub': this.billing_email_address_sub,
                    'payment_method': this.payment_method,
                    'token': tkn,
                };
                axios.post('/documents/admin_user_update', params)
                .then(res => {
                  this.success = res.data.success;
                  this.message = res.data.message;
                  if (this.success) {
                    window.location = "/documents/dashboard";
                  }
                })
                .catch(function (res) {
                  this.success = false;
                  this.message = "処理に失敗しました";
                }).finally(() => {
                  this.sending = false;
                });
              }
            });
          },
        },
        // プラン名初期表示
        mounted() {
            axios.get('/documents/get_plan').then(res => {
                this.plan = res.data.val.plan_identifier;
                this.aid = res.data.aid;
            });
        },
        computed: {
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            },
        },
  };
</script>